import { Alert, Loader, Modal } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { legacyReportCorrectionService } from "../../../services/legacyReportCorrection.service";
import LegacyReportCorrectionEditor from "./LegacyReportCorrectionEditor";
import { useLegacyImportedCase } from "../../../hooks/useLegacyCases";
import LegacyTechnicalReportNotice from "../legacy-cases/LegacyTechnicalReportNotice";

interface Props {
  caseId: string;
  opened: boolean;
  onClose: () => void;
}

export default function LegacyReportCorrectionModal({
  caseId,
  opened,
  onClose,
}: Props) {
  const legacy = useLegacyImportedCase(caseId, opened);
  const query = useQuery({
    queryKey: ["legacy-report-correction-base", caseId],
    queryFn: () => legacyReportCorrectionService.get(caseId),
    enabled: opened && legacy.data?.reportKind === "pathology",
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
  if (!opened) return null;
  if (legacy.data?.reportKind === "technical")
    return (
      <Modal
        opened
        onClose={onClose}
        title="Original technical report"
        centered
      >
        <LegacyTechnicalReportNotice caseId={caseId} />
      </Modal>
    );
  if (
    legacy.isLoading ||
    legacy.error ||
    legacy.data?.reportKind !== "pathology" ||
    query.isFetching ||
    query.error ||
    !query.data?.legacyBaseline
  )
    return (
      <Modal
        opened
        onClose={onClose}
        title="Correct historical report identity"
        centered
      >
        <Alert color={legacy.error || query.error ? "red" : "blue"}>
          {legacy.isLoading || query.isFetching ? (
            <Loader aria-label="Loading historical report identity" />
          ) : (
            legacy.error?.message ||
            query.error?.message ||
            "An approved historical baseline is required for correction."
          )}
        </Alert>
      </Modal>
    );
  return (
    <LegacyReportCorrectionEditor
      caseId={caseId}
      header={query.data.legacyReportHeader || query.data.legacyBaseline.header}
      onClose={onClose}
    />
  );
}
